export default __webpack_public_path__ + "static/media/User_CourseDetailsHeader.038c3e95.svg";